var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.needsShowing)?_c('div',{staticClass:"rankingIcon"},[_c('p',{staticClass:"rankingIcon-text"},[_vm._v(" 第"),_c('span',{staticClass:"rankingIcon-number"},[_vm._v(_vm._s(_vm.number))]),_vm._v("位 ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }